import React, { PropsWithChildren } from "react";
import { investorPortalWhiteLabelRoutes } from "../../../defines";
import { buildRouteUrl } from "../../../utils";
import {
  EditingTargetData,
  ManagerProfileEditingSection,
  ManagerProfileProviderProps,
  ManagerProfileState,
} from "./ManagerProfileProvider.types";

export const ManagerProfileContext = React.createContext<ManagerProfileState>(
  {} as ManagerProfileState,
);

export const ManagerProfileProvider: React.FC<
  PropsWithChildren<ManagerProfileProviderProps>
> = ({ manager, isEditor, children }) => {
  const [editingDrawer, setEditingDrawer] =
    React.useState<ManagerProfileEditingSection | null>(null);
  const [editingTargetData, setEditingTargetData] =
    React.useState<EditingTargetData | null>(null);

  const buildManagerProfileRouteUrl: ManagerProfileState["buildManagerProfileRouteUrl"] =
    (urlParams) => {
      return buildRouteUrl(
        investorPortalWhiteLabelRoutes.whiteLabel,
        urlParams,
      );
    };

  return (
    <ManagerProfileContext.Provider
      value={{
        manager,
        setEditingDrawer,
        setEditingTargetData,
        isEditing: !!isEditor,
        isEditor: isEditor || false,
        isPublic: true,
        editingTargetData,
        buildManagerProfileRouteUrl,
        editingDrawer,
      }}
    >
      {children}
    </ManagerProfileContext.Provider>
  );
};

export const useManagerProfile = (skipError = false) => {
  const context = React.useContext(ManagerProfileContext);
  if (context === undefined && !skipError) {
    throw new Error(
      "useManagerProfile must be used within a ManagerProfileProvider",
    );
  }
  return context;
};
